import React from 'react';
import './person-detail.css';

function PersonDetail({detailClass}) {
    return (
        <div className={'person-detail'}>
            <img src={`/img/max-class/${detailClass.imagem_classe?.toLowerCase()}`} alt={detailClass.nome}
                 className={'class-category'}/>
            <h2>{detailClass.nome}</h2>
            {detailClass.descricao}

            <h3>Skills</h3>
            <table className={'table-data'}>
                <thead>
                <tr>
                    <th>Ataque</th>
                    <th>Defesa</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className={'content'}>
                        {detailClass.ataques?.map((skill, index) => (
                            <div key={index}>
                                <h4>{skill.nome}</h4>
                                {skill.descricao} <br/>
                                <b>Dano Físico: </b> {skill.dano_fisico} <br/>
                                <b>Dano Mágico: </b> {skill.dano_magico} <br/>
                            </div>
                        ))}
                    </td>
                    <td className={'content'}>
                        {detailClass.defesas?.map((skill, index) => (
                            <div key={index}>
                                <h4>{skill.nome}</h4>
                                {skill.descricao} <br/>
                                <b>Defesa Física: </b> {skill.reducao_dano_fisico} <br/>
                                <b>Defesa Mágica: </b> {skill.reducao_dano_magico} <br/>
                            </div>
                        ))}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}

export default PersonDetail;